/**
 * Nome do módulo, para a linha "ARTEFATO · Tabela · CRM" do card de prévia do
 * painel de artefato (redesign visual, plano `moonlit-conjuring-sun`).
 *
 * Espelha `resolver-icone-do-modulo.js` byte a byte na estrutura: as MESMAS
 * duas fontes, na MESMA ordem, só que lendo `label`/`title` em vez de `icon`.
 *
 * Duas fontes, nessa ordem:
 * 1. `GESTAO_GROUPS`/`CLIENTE_GROUPS` (`navigation-modules.js`) — chaveado
 *    pela `key` de módulo (`crm`, `bi`, `financeiro`, `tarefas`,
 *    `partnership`, ...), com `label` já pronto (`d.title.trim()`).
 * 2. `ROUTE_DEFS` (`navigation-routes.js`) — chaveado por `ROUTE_KEYS`, com
 *    `title` (rótulo VERBATIM, acentos e espaços do original).
 *
 * Módulo sem nome mapeado em nenhuma das duas cai em string vazia — ao
 * contrário do ícone, aqui não há fallback genérico ("Ferramentas" não é
 * nome de módulo): o card só não mostra esse segmento da linha.
 *
 * Função PURA: sem leitura de store, sem `this`, sem I/O — só dados estáticos
 * dos dois catálogos.
 *
 * Sem `?.`/`??` (o Babel deste projeto não transpila). Acentos UTF-8 reais.
 */
import { GESTAO_GROUPS, CLIENTE_GROUPS } from '@modules/navegacao-v2/constants/navigation-modules'
import { ROUTE_DEFS } from '@constants/navigation-routes'

function achatarGrupos(grupos) {
  const itens = []
  ;(grupos || []).forEach((grupo) => {
    ;(grupo.items || []).forEach((item) => itens.push(item))
  })
  return itens
}

// Mapa `moduleKey → label`, construído uma vez a partir do esqueleto ESTÁTICO
// da navegação (nenhum dos dois catálogos depende de `$access`/sessão).
function construirMapaDeNomes() {
  const mapa = {}

  achatarGrupos(GESTAO_GROUPS)
    .concat(achatarGrupos(CLIENTE_GROUPS))
    .forEach((item) => {
      if (item && item.key && item.label && !mapa[item.key]) {
        mapa[item.key] = item.label
      }
    })

  Object.keys(ROUTE_DEFS).forEach((chave) => {
    const def = ROUTE_DEFS[chave]
    if (def && def.title && !mapa[chave]) {
      mapa[chave] = def.title
    }
  })

  return mapa
}

let mapaDeNomesCache = null

function mapaDeNomes() {
  if (!mapaDeNomesCache) mapaDeNomesCache = construirMapaDeNomes()
  return mapaDeNomesCache
}

/**
 * Resolve o nome do módulo (segmento antes da `/` em `ui.component`, ex.:
 * `crm` de `crm/confirmacao`) para o card de prévia do artefato.
 *
 * @param {string} moduleKey
 * @returns {string} nome do módulo, ou `''` quando não encontrado.
 */
export function resolverNomeDoModulo(moduleKey) {
  if (!moduleKey) return ''
  return mapaDeNomes()[moduleKey] || ''
}
